'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _max3 = require('lodash/max');

var _max4 = _interopRequireDefault(_max3);

var _keyBy3 = require('lodash/keyBy');

var _keyBy4 = _interopRequireDefault(_keyBy3);

var _groupBy3 = require('lodash/groupBy');

var _groupBy4 = _interopRequireDefault(_groupBy3);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

exports.processReport = processReport;
exports.processRecipientReport = processRecipientReport;

var _projects = require('helpers/projects');

var _recipients = require('helpers/recipients');

var _datetime = require('helpers/datetime');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function processReport(data) {
  var processedData = (0, _extends3.default)({}, data);
  processedData.project = (0, _projects.processProject)(processedData.project || {});
  var _processedData$averag = processedData.averageStat,
      averageStat = _processedData$averag === undefined ? [0] : _processedData$averag;

  processedData.maxPlaysNumber = (0, _max4.default)(averageStat.map(function (stat) {
    return stat.nbPlays;
  }));
  processedData.files = (0, _keyBy4.default)(processedData.listfiles, 'uploadId');
  processedData.viewers = (0, _recipients.processRecipients)(processedData.Views || []);
  processedData.nonViewers = (0, _recipients.processRecipients)(processedData.nonViews || []);
  processedData.downloadedViewers = (0, _keyBy4.default)(processedData.DownloadList, 'recipientId');
  return processedData;
}

function processRecipientFiles(files, timings) {
  return files.map(function (file) {
    var fileTimings = (0, _get4.default)(timings, [file.uploadId], []);
    var playCount = fileTimings.length;
    var playtime = fileTimings.reduce(function (timing1, timing2) {
      return (0, _get4.default)(timing1, 'listeningDuration', timing1) + (0, _get4.default)(timing2, 'listeningDuration', 0);
    }, 0);
    var avgPlaytime = playtime / (playCount || 1);

    return (0, _extends3.default)({}, file, {
      durationMinutes: (0, _datetime.secToMin)(file.duration),
      playCount: playCount,
      avgPlaytime: avgPlaytime,
      avgPlaytimeMinutes: (0, _datetime.secToMin)(avgPlaytime)
    });
  });
}

function processTimings(timings) {
  return timings.map(function (timing) {
    return (0, _extends3.default)({}, timing, {
      durationMinutes: (0, _datetime.secToMin)(timing.listeningDuration),
      durationString: (0, _datetime.secToMinString)(timing.listeningDuration),
      dateString: (0, _datetime.formatDateTime)(timing.date)
    });
  });
}

function processRecipientReport(data) {
  var processedData = (0, _extends3.default)({}, data);
  processedData.fileTimings = (0, _groupBy4.default)(processedData.Timings, 'uploadId');
  processedData.filesArray = processRecipientFiles(processedData.listfiles || [], processedData.fileTimings);
  processedData.files = (0, _keyBy4.default)(processedData.filesArray, 'uploadId');
  processedData.maxPlaysNumber = (0, _max4.default)(processedData.filesArray.map(function (file) {
    return file.playCount;
  }));
  processedData.timings = processTimings(processedData.Timings || []);
  return processedData;
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/reports.js
// module id = 2228
// module chunks = 1